export enum DestinationMode {
  DESTINATION = 'DESTINATION',
  WAREHOUSE = 'WAREHOUSE'
}
